import React from "react";
import { CheckCircle2, AlertTriangle, CircleCheck, Merge } from "lucide-react";

export const STATUS_LABEL = {
  serviced: "Serviced",
  not_serviced: "Not serviced",
  paid_off: "Paid off",
  consolidated: "Consolidated",
};

export const STATUS_COLOR = {
  serviced: { bg: "#E5EFE7", border: "#829A88", text: "#2C4A3B" },
  not_serviced: { bg: "#FAEEE5", border: "#E07A5F", text: "#B04A32" },
  paid_off: { bg: "#EEEBE2", border: "#C5CFC3", text: "#1D3328" },
  consolidated: { bg: "#EDECF4", border: "#A9A3C4", text: "#4B4478" },
};

const ICON = {
  serviced: CheckCircle2,
  not_serviced: AlertTriangle,
  paid_off: CircleCheck,
  consolidated: Merge,
};

export default function StatusBadge({ status, size = "sm" }) {
  const Icon = ICON[status] || CheckCircle2;
  const c = STATUS_COLOR[status] || STATUS_COLOR.serviced;
  const sizing = size === "lg"
    ? "text-xs px-3 py-1.5"
    : "text-[10px] px-2 py-1";
  return (
    <span
      className={`inline-flex items-center gap-1 font-medium tracking-widest uppercase rounded-md border ${sizing}`}
      style={{ background: c.bg, borderColor: c.border, color: c.text }}
      data-testid="status-badge"
      data-status={status}
    >
      <Icon className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} strokeWidth={1.8} />
      {STATUS_LABEL[status] || status}
    </span>
  );
}
